import React, { useMemo } from "react";
import "./NotFound.css";

const NotFound = ({ msg, statusCode = "404" }) => {
  const isForbidden = statusCode === "403";

  const eyebrow = isForbidden ? "Access denied" : "Page not found";
  const heading = isForbidden
    ? "You don't have permission to view this webcast."
    : "We couldn't find the webcast you're looking for.";
  const body = isForbidden
    ? "Please contact the event organiser if you believe this is a mistake."
    : "The link may be incorrect, expired, or the event may no longer be available.";

  return (
    <div className={isForbidden ? "nf-root nf-403" : "nf-root nf-404"}>
      <div className="nf-scrim" />
      <div className="nf-center">
        <div className="nf-card" role="status" aria-live="polite">
          <span className="nf-eyebrow">{eyebrow}</span>
          <div className="nf-code" aria-hidden="true">{statusCode}</div>
          <div className="nf-rule" />
          <p className="nf-heading">{heading}</p>
          <p className="nf-body">{body}</p>
          {msg && <p className="nf-detail">{msg}</p>}
        </div>
      </div>
    </div>
  );
};

export default React.memo(NotFound);
